import { ChildrenItem } from "dependencies/base"
import { Baidumap } from "./model"
import { home, bs, appHome } from "./diffrence_options"
import bigScreenIcon from "assets/images/leftMenu/component/cx_date.png"
let icon = "icon-portal-map"
export let baidumap_children = []
export let bigScreen_baidumap_children = []
export let app_baidumap_children = []
for (let i = 0; i < home.length; i++) {
  baidumap_children.push(new ChildrenItem("百度地图样式" + i, icon, "cxBaidumap", new Baidumap(home[i])))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_baidumap_children.push(new ChildrenItem("百度地图样式" + i, bigScreenIcon, "cxBaidumap", new Baidumap(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_baidumap_children.push(new ChildrenItem("百度地图样式" + i, icon, "cxBaidumap", new Baidumap(appHome[i])))
}
